import { Injectable } from '@angular/core';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { ModifyDco } from '../modify/modify-dco';
import { RepeatDco } from '../repeat/repeat-dco';
import { CreateDco } from '../create/create-dco';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowDcoService {
  /**
   * Subject to notify should ignore changes on DCO fields
   */
  ignoreDcoChangesNotification$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Subject to notify should reset DCO by warning modal
   */
  resetDcoByWarningModal$: Subject<number> = new Subject<number>();

  /**
   * Flag used to let UnloadTypeOnChangeService know that its function got triggered
   * by pressing the Cancel button on the warning modal.
   * This is to avoid the modal showing up again after closing it, caused by the
   * pump primer fields resetting.
   */
  didCloseWarningModal$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private store: Store<State>,
    private featureToggle: FeatureToggleService,
  ) {}

  validateWorkflow(isModify: boolean, isRepeat: boolean, isNewWaitingList: boolean = false): any {
    if (isModify) {
      return new ModifyDco(
        this.store,
        this.featureToggle,
        this.ignoreDcoChangesNotification$,
        this.resetDcoByWarningModal$,
        this.didCloseWarningModal$,
        isNewWaitingList,
      );
    } else if (isRepeat) {
      return new RepeatDco(this.store, this.featureToggle, this.didCloseWarningModal$);
    } else {
      return new CreateDco(this.store, this.featureToggle, this.didCloseWarningModal$);
    }
  }
}
